import { useNavigate } from "react-router-dom";

const PrivacyPolicy = () => {
  const navigate = useNavigate();
  return (
    <main className="dashboardLayoutSubSection rounded-xl">
      <section className="max-w-4xl mx-auto px-6 py-10">
        <button
          onClick={() => navigate(-1)}
          className="bg-myButtonBg hover:bg-myLabelText cursor-pointer text-white px-6 py-2 rounded-md"
        >
          Back
        </button>
        <h1 className="text-3xl font-bold text-gray-800 mb-2 text-center">
          Privacy Policy
        </h1>
        <p className="text-sm text-gray-500 text-center mb-6">
          Last Updated: 27th September, 2025
        </p>

        <p className="text-gray-600 mb-6">
          At LLB360, a product of Saadruso Internet Media Pvt Ltd. ("Company,"
          "we," "our," "us"), your privacy is important to us. This Privacy
          Policy explains how we collect, use, share, and protect your personal
          information when you use our educational platform, website, and mobile
          application ("Services"). By using our Services, you consent to the
          practices described in this Policy.
        </p>

        <ol className="list-decimal list-inside space-y-4 text-gray-700">
          <li>
            <span className="font-semibold text-gray-800">
              Information We Collect
            </span>
            <ul className="list-disc list-inside pl-6 mt-2 space-y-2 text-gray-600">
              <li>
                <span className="font-semibold">a) Personal Information</span>
                <ul className="list-disc list-inside pl-6 space-y-1">
                  <li>
                    Name, email address, phone number, and profile details.
                  </li>
                  <li>Account login credentials.</li>
                  <li>
                    Payment details (processed through secure third-party
                    gateways; we do not store card details).
                  </li>
                </ul>
              </li>
              <li>
                <span className="font-semibold">b) Academic & Usage Data</span>
                <ul className="list-disc list-inside pl-6 space-y-1">
                  <li>
                    Course enrollments, progress reports, mock test scores, and
                    study activity.
                  </li>
                  <li>
                    Device details (IP address, browser type, operating system).
                  </li>
                  <li>Usage patterns to improve learning recommendations.</li>
                </ul>
              </li>
              <li>
                <span className="font-semibold">c) Optional Information</span>
                <ul className="list-disc list-inside pl-6 space-y-1">
                  <li>Feedback, queries, or support requests you submit.</li>
                  <li>
                    Content you share in discussion forums, comments, or
                    peer-learning spaces.
                  </li>
                </ul>
              </li>
            </ul>
          </li>

          <li>
            <span className="font-semibold text-gray-800">
              How We Use Your Information
            </span>
            <ul className="list-disc list-inside pl-6 mt-2 space-y-2 text-gray-600">
              <li>Provide access to our courses, notes, and mock tests.</li>
              <li>
                Personalize your learning experience with recommendations.
              </li>
              <li>Process payments and manage subscriptions.</li>
              <li>
                Communicate with you regarding updates, new features, or
                support.
              </li>
              <li>Improve our platform performance and security.</li>
              <li>Comply with legal obligations.</li>
            </ul>
          </li>

          <li>
            <span className="font-semibold text-gray-800">
              Sharing of Information
            </span>
            <ul className="list-disc list-inside pl-6 mt-2 space-y-2 text-gray-600">
              <li>
                We do not sell or rent your personal data. However, we may share
                it with:
              </li>
              <li>
                Service Providers: Secure payment processors, cloud hosting,
                analytics tools.
              </li>
              <li>
                Legal Authorities: If required under applicable law or legal
                process.
              </li>
              <li>
                Affiliates & Partners: For academic collaborations, only with
                your consent.
              </li>
            </ul>
          </li>

          <li>
            <span className="font-semibold text-gray-800">Data Security</span>
            <ul className="list-disc list-inside pl-6 mt-2 space-y-2 text-gray-600">
              <li>
                We use encryption, firewalls, and secure servers to protect your
                data.
              </li>
              <li>
                While we take reasonable measures, no online system is 100%
                secure. Users are encouraged to safeguard their account
                credentials.
              </li>
            </ul>
          </li>

          <li>
            <span className="font-semibold text-gray-800">Data Retention</span>
            <ul className="list-disc list-inside pl-6 mt-2 space-y-2 text-gray-600">
              <li>
                Personal data is retained as long as you have an active account.
              </li>
              <li>
                Upon account deletion, data is securely deleted or anonymized,
                unless retention is required by law (e.g., financial
                transactions).
              </li>
            </ul>
          </li>

          <li>
            <span className="font-semibold text-gray-800">
              Your Rights (as per Indian DPDP Act, 2023)
            </span>
            <ul className="list-disc list-inside pl-6 mt-2 space-y-2 text-gray-600">
              <li>Access and request a copy of your data.</li>
              <li>Correct or update inaccurate information.</li>
              <li>Withdraw consent for optional data usage.</li>
              <li>
                Request deletion of your personal data (subject to legal
                requirements).
              </li>
              <li>Opt-out of marketing communications.</li>
            </ul>
            <p className="mt-2 text-gray-600">
              To exercise these rights, contact us at contact@llb360.com.
            </p>
          </li>

          <li>
            <span className="font-semibold text-gray-800">
              Cookies & Tracking
            </span>
            <ul className="list-disc list-inside pl-6 mt-2 space-y-2 text-gray-600">
              <li>
                We use cookies and similar technologies to enhance your
                experience, analyze usage, and deliver relevant content.
              </li>
              <li>
                You can manage cookie preferences in your browser settings.
              </li>
            </ul>
          </li>

          <li>
            <span className="font-semibold text-gray-800">
              Children’s Privacy
            </span>
            <ul className="list-disc list-inside pl-6 mt-2 space-y-2 text-gray-600">
              <li>
                Our Services are designed for students 13 years and older.
              </li>
              <li>
                If you are under 18, you may use our Services only with
                parental/guardian consent.
              </li>
              <li>
                We do not knowingly collect personal data from children under
                13.
              </li>
            </ul>
          </li>

          <li>
            <span className="font-semibold text-gray-800">
              Third-Party Links
            </span>
            <p className="mt-2 text-gray-600">
              Our platform may contain links to third-party sites. We are not
              responsible for their privacy practices and encourage you to
              review their policies.
            </p>
          </li>

          <li>
            <span className="font-semibold text-gray-800">
              Changes to this Policy
            </span>
            <p className="mt-2 text-gray-600">
              We may update this Privacy Policy from time to time. Changes will
              be posted on this page with the "Last Updated" date. Continued use
              of Services signifies acceptance of the updated Policy.
            </p>
          </li>

          <li>
            <span className="font-semibold text-gray-800">Contact Us</span>
            <p className="mt-2 text-gray-600">
              For any questions about this Privacy Policy, please reach out to:
            </p>
            <ul className="list-disc list-inside pl-6 mt-2 space-y-2 text-gray-600">
              <li>Saadruso Internet Media Pvt Ltd.</li>
              <li>Email: contact@llb360.com</li>
              <li>Phone: 7673937360</li>
              <li>
                Address: Plot # 28, Doyens Township, Serilingampally, Hyderabad
                – 500 019
              </li>
            </ul>
          </li>
        </ol>
      </section>
    </main>
  );
};

export default PrivacyPolicy;
